import groq from 'groq';

import type { SanityClientFetchOptions } from '../../data/sanity/types';
import { logs } from '../../utils/logs';
import { executeQuery } from './SanityServiceSimple.utils';

export const SanityServiceSimple = {
  async fetch<T>(
    query: string,
    options: SanityClientFetchOptions = {},
    context: Record<string, any> = {}
  ): Promise<T> {
    try {
      return await executeQuery(query, options);
    } catch (error) {
      logs.error(
        {
          sanityServiceSimple: {
            ...context,
            query,
            options,
            exception: JSON.stringify(error),
          },
        },
        'SANITY_FETCH_ERROR'
      );

      throw error;
    }
  },

  async batch<T>(
    queries: string[],
    options: SanityClientFetchOptions = {},
    context: Record<string, any> = {}
  ): Promise<T> {
    const combinedQuery = groq`[
      ${queries.join(',\n')}
    ]`;

    try {
      return await executeQuery(combinedQuery, options);
    } catch (error) {
      logs.error(
        {
          sanityServiceSimple: {
            ...context,
            queriesCount: queries.length,
            query: combinedQuery,
            options,
            exception: JSON.stringify(error),
          },
        },
        'SANITY_BATCH_ERROR'
      );

      throw error;
    }
  },
};
